module.exports = __webpack_public_path__ + "img/satisfaction-moyenne.02c9f1e7.svg";